export const ImgResIndex = {
  HIGH: '1020',
  MEDIUM: '765',
  LOW: '510'
};
